import type { FaireProductEntity } from "../../entity_types/product";

export const p_7q00o2wpz9: FaireProductEntity = {
  token: "p_7q00o2wpz9",
  type: "product",
  name: "Big Heart Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9428d987bcdac79664828bfb2fa8b6c8e2abac88eb6c8c7fc24f528b06b55c06.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef23e4e9ed940b89b5c4c25c075878996a0a420863524430ff26ccab51cbacec.jpeg",
    "https://cdn.faire.com/fastly/66f2c3a9290a0a853ad69745c3818da66eca65a8f9fd630171866436ed654705.jpeg",
    "https://cdn.faire.com/fastly/5ef7e54fa35d4cc8729627beec39e8062f5e9bb4a41e1e7f0a7b6a8b1a11fb44.jpeg",
    "https://cdn.faire.com/fastly/d97fd5e5171e2014acbe5704ff4090ffce95429f79ce2d2062077597235df42e.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:25.832Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
